module.exports = __webpack_public_path__ + "media/images/general/image-crop-19dc78556aed3606bd0098821ba48dc2.jpg";